// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class MedicalBiSiteOfCareResult {
    'name'?: string;
    'networkStatus'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof MedicalBiSiteOfCareResult>> = [
        {
            "name":     "name",
            "baseName": "name",
            "type":     "string"
        },
        {
            "name":     "networkStatus",
            "baseName": "networkStatus",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return MedicalBiSiteOfCareResult.attributeTypeMap;
    }
}
